<template>
  <section class="card">
    <transition name="modal" mode="in-out">
      <modal v-if="modals.show"
             :closemodal="cancelar"
             @salvar="salvar"
             :errors="this.$root.errors"
             :title="getModalTitle()"
             :size="'modal-md'">
        <template slot="body">
          <form>
            <input type="hidden" v-model="itemSelecionado[0].Id" />
            <div class="form-group">
              <label for="Descricao">Descrição</label>
              <input type="text" ref="descricao" v-focus class="form-control form-control-sm" v-model="itemSelecionado[0].Descricao" id="Descricao">
            </div>
            <div class="form-row">

              <div class="form-group col-md-6">
                <label asp-for="TipoPerfil"></label>
                <select v-model="itemSelecionado[0].TipoPerfil"
                        asp-for="TipoPerfil"
                        class="form-control form-control-sm">
                  <option value="0">Administrador</option>
                  <option value="1">Diretor</option>
                  <option value="2">Gerente</option>
                  <option value="3">Outros</option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label for="Ativo">Ativo</label>
                <div class="checkbox-custom chekbox-primary">
                  <input id="Ativo" value="true" type="checkbox" v-model="itemSelecionado[0].Ativo" name="Ativo" required="">
                  <label for="Ativo"></label>
                </div>
              </div>
            </div>
          </form>
        </template>
        <template v-slot:footer="slotFooterProps">
          <button class="btn btn-sm pull-right btn-primary modal-confirm"
                  @click="slotFooterProps.clickHandler('salvar')">
            Salvar
          </button>
        </template>
      </modal>
    </transition>

    <data-header :handleTrocarVisao="handleTrocarVisao"
                 :filtros="filtros"
                 :itemSelecionado="itemSelecionado"
                 :actionButtons="actionButtons">
      <template slot="header" >
        <span class="selecionado" v-html="selecionado">
        </span>
      </template>
    </data-header>
    <div class="row main-row">
      <filtro-component :filtros="filtros"
                        :params="params"
                        :handleConsultar="handleConsultar">
      </filtro-component>
      <data-table :result="result"
                  :params="params"
                  :handleRowClick="handleRowClick"
                  :checkboxClass="resolveCheckboxClass"
                  :itemSelecionado="itemSelecionado[0]"
                  :resolveStatusClass="resolveStatusClass"
                  :handleOrdenar="handleOrdenar"
                  :selected="selected"
                  :filtros="filtros"
                  :handleConsultar="handleConsultar"
                  :actionButtons="actionButtons">
      </data-table>
    </div>
  </section>
</template>

<script>
import consultar from '@/services/consultar.js';

//perfis
export default {

    components: {
        ...consultar.components,

    },
    data() {
        const that = this;
        return {
            ...consultar.data(),
            url: '/configuracoes/perfis',
            clone: '',
            obj: {},
            actionButtons: [
                {
                    text: 'Editar',
                    className: 'editar padrao',
                    icon: 'fas fa-edit',
                    color: 'default',
                    visible: true,// inicial
                    visibleOnRowSelected: true,
                    title: 'Editar item selecionado',
                    callback: that.handleEditarButton
                },
                {
                    text: 'Novo Perfil',
                    className: 'novo padrao',
                    icon: 'fas fa-plus',
                    color: 'default',
                    visible: true,
                    title: 'Incluir novo perfil',
                    callback: that.handleNovoButton
                },
                {
                    text: '',
                    className: 'excel padrao',
                    icon: 'fas fa-file-excel',
                    iconColor: 'green',
                    color: 'default',
                    visible: true,
                    title: 'Exportar para excel',
                    callback: that.exportar
                },
            ],
            filtros:
            {
                data: [
                    {
                        id: 'descricao',
                        title: 'Descrição',
                        active: false,
                        placeholder: '',
                        //value: 'zueira'
                    },
                    {
                        id: 'Ativo',
                        title: 'Status',
                        active: false,
                        value: 'true',
                        source: [
                            {
                                id: 'Ativo',
                                title: 'Ativo',
                                value: 'true'
                            },
                            {
                                id: 'Ativo',
                                title: 'Inativo',
                                value: 'false'
                            }
                        ],
                        sourceType: 'radio'
                    }
                ],
                visao: [
                    {
                        id: 0,
                        title: 'Todos perfis',
                        filtro: []
                    },
                    {
                        id: 1,
                        title: 'Perfis Ativos',
                        filtro:
                            [
                                {
                                    id: 'Ativo',
                                    value: true,
                                },
                            ]
                    }
                ],
                visaoSelecionada: 0,
                visible: true
            }
        };
    },

    methods: {
        ...consultar.methods,
        handleNovoButton: function () {
            this.$root.errors = [];
            this.selected.pop();
            this.itemSelecionado.pop();
            this.itemSelecionado.push({
                Id: 0,
                Ativo: true,
                TipoPerfil: 3
            });

            this.modals.show = true;

        },

    },
    mounted: consultar.mounted,

    beforeMount: function () {

    }
};
</script>
